<template>
    <div class="contract-manage-iflow-table">
        <table-box v-loading="subTabTable.tableLoading" :selection="TABLECONFIG.selection"
            :columns="TABLECONFIG.columns" :height="tableHeight" :actions="TABLECONFIG.actions"
            :rows="subTabTable.totalData" @action-click="actionClick"
            @sort-change="handleSort">
            <template #col-header="score">
                <span>{{ score.col.label }}</span>
                <el-popover
                    placement="bottom"
                    title="筛选条件"
                    :width="200"
                    >
                        <el-input v-if="score.col.headerType === 'input'" v-model="searchHeaderParams[score.col.prop]"
                            @blur="getheaderParamList()"  @keyup.enter.native="getheaderParamList()"
                            :placeholder="score.col.placeholder || `请输入${ score.col.label }`"  clearable @clear="getheaderParamList()"></el-input>
                        <lots-select
                            v-else-if="score.col.headerType === 'select'"
                            :optionsKey="score.col.params.params.optionsKey ||'' "
                            :placeholder="score.col.placeholder || `请选择${ score.col.label }`"
                            v-model="searchHeaderParams[score.col.prop]"
                            @change="getheaderParamList()"
                            clearable
                            style="width: 100%" />

                        <i slot="reference" v-if="score.col.headerType"  @click.stop="changeVisible()"
                        :class="[changeIconActive(searchHeaderParams[score.col.prop]), 'price-icon iconfont icon-ad-search']"></i>
                </el-popover>
            </template>
        </table-box>
        <div class="footer">
            <lots-pagination @size-change='subTabTable.sizeChange' :current-page.sync='subTabTable.pageNo'
                @current-change='subTabTable.pageChange' size="small" layout='total, sizes, prev, pager, next, jumper'
                :total='subTabTable.pageTotal' />
        </div>
        <div id="closeMainVisible"></div>
    </div>
</template>

<script>
import lotsPagination from '@/components/lots/lotsPagination/Index';
import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
import { getHistotyList } from '@mdm/api/contractManage/contractRegistration.js';
import { ref, watch, computed, reactive, toRefs } from '@vue/composition-api';
import { tableConfig } from './config.js';
import lotsSelect from '@/components/lots/lotsSelect/Index';
import tableBox from '@/components/lots/tableBox/Index';
import { getDictDataApi } from '@mdm/api/contractManage/contractListApi.js';
import _ from 'lodash';
export default {
    components: {
        lotsPagination, tableBox, lotsSelect
    },
    props: {
        activeName: {
            type: String,
            default: () => ''
        },
        detailPageState: {
            type: String,
            default() {
                return '';
            }
        },
        detailData: {
            type: Object,
            return: () => {}
        },
        tableHeight: {
            type: Number,
            default: 357
        },
        actions: { // 表格操作信息，不传默认为空
            type: Object,
            default() {
                return {
                    list: []
                };
            }
        }
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const config = reactive(tableConfig);
        // eslint-disable-next-line complexity
        const TABLECONFIG = computed(() => {
            return config;
        });
        const convertEmptyStringsToNull = (obj) => {
            return _.mapValues(obj, value => {
                if (typeof value === 'string') {
                    return _.trim(value) === '' ? null : value;
                }
                return value;
            });
        };
        class IhistoryTalbeClass extends AdvanceListClass {
            beforeGetList(condition) {
                condition.contractCode = props.detailData.contractCode;
                condition.concertId = props.detailData.id;
                condition.orderBy = orderBy.value;
                condition.orderByType = orderByType.value;
                condition = convertEmptyStringsToNull(condition);
                return condition;
            }
            afterGetList(res) {
                if (+res.code === 0 && res.data && res.data.list) {
                    subTabTable.totalData.value = res.data.list.map(it => {
                        if (+it.valueType === 4) {
                            let oldValue = codesToNames(it.oldValue, dictData.value[it.valueFormat]);
                            let newValue = codesToNames(it.newValue, dictData.value[it.valueFormat]);
                            // 临时改动 下版本改用调dc获取停用的字典值进行转换 当前版本0108
                            if (it.updateFieldCode === 'renewalStatus' && it.oldValue?.toString() === '1') {
                                oldValue = '洽谈中';
                            }
                            if (it.updateFieldCode === 'renewalStatus' && it.newValue?.toString() === '1') {
                                newValue = '洽谈中';
                            }
                            it.oldValue = oldValue;
                            it.newValue = newValue;
                            return it;
                        }
                    });
                }
                super.afterGetList(res);
            }
        };
        const subTabTable = new IhistoryTalbeClass({
            Api: {
                listApi: getHistotyList
            }
        });
        watch(
            () => [props.activeName],
            async (newVal, oldVal) => {
                if (newVal[0] === 'history') {
                    await getDictData();
                    subTabTable.getList();
                }
            }
        );
        const codesToNames = (codes, dictObj) => {
            if (codes === '' && _.isNil(codes)) return;
            const names = [];
            const codesArr = codes ? codes.split(',') : [];
            if (codesArr && codesArr.length) {
                codesArr.forEach((key) => {
                    if (dictObj && dictObj[key]) {
                        names.push(dictObj[key]); // dictData.value['SYS_BMS_BUSI_TYPE']
                    }
                });
            }
            return names.join(',');
        };
        const dictData = ref({});
        const getDictData = async () => {
            const codes = ['CRM_CONTRACT_RENEWAL_STATUS', 'CRM_CONTRACT_RENEWAL_RISK', 'CRM_CONTRACT_RENEWAL_RISK_CAUSE', 'CRM_CONTRACT_EXIT_STATUS',
                'CRM_CONTRACT_CAUSE_CATEGORIES', 'CRM_CONTRACT_CAUSE_SUBCATEGORY', 'CRM_CONTRACT_RENEWAL_UPSTREAM', 'CRM_CONTRACT_RENEWAL_DOWNSTREAM'];
            return getDictDataApi({
                dictCodes: String(codes)
            }).then(res => {
                if (res && +res.code === 0) {
                    dictData.value = res.data;
                }
            });
        };
        const changeVisible = () => {
            document.getElementById('closeMainVisible').click(); // doClose失效 ,Visible 绑定无法更新到视图 用于关闭其他el-popover弹窗
        };
        const state = reactive({
            searchHeaderParams: {}
        });
        const getAdvanceValue = (data, item) => {
            state.searchHeaderParams[item.prop] = data[item.prop];
            subTabTable.getList(state.searchHeaderParams);
        };
        const getheaderParamList = () => {
            subTabTable.getList(state.searchHeaderParams);
            // changeVisible();
        };
        const orderBy = ref('create_time');
        const orderByType = ref('desc');

        // 排序
        const handleSort = ({ prop, order }) => {
            orderBy.value = prop.replace(/([A-Z])/g, '_$1').toLowerCase();
            orderByType.value = order === 'ascending' ? 'asc' : 'desc';
            subTabTable.getList(state.searchHeaderParams);
        };
        const errlist = [undefined, null, ''];
        const changeIconActive = (row) => {
            return errlist.includes(row) ? '' : 'icon-active';
        };
        // onActivated(() => {
        //     getDataFn();
        // });
        // const getDataFn = () => {
        //     props.activeName === 'history'
        //         && subTabTable.getList();
        // };
        const actionClick = (event, row) => {
            if (event === 'abandom') {
                subTabTable.deleteRow({ mipId: row.mipId }, {
                    msg: '请确认是否特权废弃该流程？该操作不可恢复',
                    successMsg: '特权废弃成功！'
                });
            }
        };
        return {
            ...toRefs(state),
            config,
            TABLECONFIG,
            dictData,
            subTabTable,
            // getDataFn,
            actionClick,
            changeVisible,
            getheaderParamList,
            changeIconActive,
            getAdvanceValue,
            handleSort,
            codesToNames
        };
    }
};
</script>
<style lang='less'>
.contract-manage-iflow-table {
    // margin-top: 15px;
    .footer {
        padding: 10px 0;
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }
    .mip-page-link {
        color: #4285f5;
        cursor: pointer;
        &.no-wrap {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
    .price-icon{
        font-size: 12px;
        cursor: pointer;
        color: #000;
    }
    .icon-active{
        color: #4285f5!important;
    }
}

</style>
